import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Contact from "@/pages/Contact";
import Shop from "@/pages/Shop";
import ShopSuccess from "@/pages/ShopSuccess";
import Booking, { BookingSuccess } from "@/pages/Booking";
import WMWELayout from "@/pages/wmwe/WMWELayout";
import WMWEHome from "@/pages/wmwe/WMWEHome";
import WMWEFellowship from "@/pages/wmwe/WMWEFellowship";
import WMWEGatherings from "@/pages/wmwe/WMWEGatherings";
import WMWEAbout from "@/pages/wmwe/WMWEAbout";
import WMWEShop from "@/pages/wmwe/WMWEShop";
import WMWEPrayer from "@/pages/wmwe/WMWEPrayer";
import WMWEHub from "@/pages/wmwe/WMWEHub";
import AdminCRM from "@/pages/admin/AdminCRM";
import PublicProposal from "@/pages/PublicProposal";
import ScrollToTop from "@/components/site/ScrollToTop";
import AuthCallback from "@/components/site/AuthCallback";
import { AuthProvider } from "@/contexts/AuthContext";

function AppRouter() {
    const location = useLocation();
    // CRITICAL: Detect session_id in URL fragment synchronously during render.
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    const isAdmin = location.pathname.startsWith("/admin");
    const isProposal = location.pathname.startsWith("/proposal/");
    return (
        <>
            {!isAdmin && !isProposal && <Navbar />}
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/shop/success" element={<ShopSuccess />} />
                <Route path="/book" element={<Booking />} />
                <Route path="/book/success" element={<BookingSuccess />} />
                <Route path="/admin" element={<AdminCRM />} />
                <Route path="/proposal/:token" element={<PublicProposal />} />
                <Route path="/wmwe" element={<WMWELayout />}>
                    <Route index element={<WMWEHome />} />
                    <Route path="fellowship" element={<WMWEFellowship />} />
                    <Route path="gatherings" element={<WMWEGatherings />} />
                    <Route path="about" element={<WMWEAbout />} />
                    <Route path="shop" element={<WMWEShop />} />
                    <Route path="prayer" element={<WMWEPrayer />} />
                    <Route path="hub" element={<WMWEHub />} />
                </Route>
            </Routes>
            {!isAdmin && !isProposal && <Footer />}
        </>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <ScrollToTop />
                    <AppRouter />
                    <Toaster
                        position="bottom-right"
                        toastOptions={{
                            style: {
                                background: "#0c0f3d",
                                color: "#fbf9f8",
                                border: "1px solid #6d91ad",
                                fontFamily: "DM Sans, sans-serif",
                            },
                        }}
                    />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
